// AUTO-GENERATED. DO NOT EDIT.
// Source: scripts/i18n/generate_i18n_catalogs.mjs

export const platformAdminExecutionRuntimeValues = {
  values: {
    accessMethodWeb: "Web",
    accessMethodSsh: "SSH",
    accessMethodRdp: "RDP",
    accessMethodVnc: "VNC",
    accessMethodPortMapping: "ポートマッピング",
    noAccessEndpoints: "アクセス端点はありません",
    workspaceAccessOnly: "実行ノード上のみアクセス可能",
    providerTypeLocal: "ローカル",
    providerTypeCenter: "アセットセンター",
    executionProviderTypeLocal: "ローカル実行",
    executionProviderTypeCenter: "実行基盤",
    providerTypeLocalRuntime: "ローカルランタイム",
    providerKeyLocalRuntimeDocker: "ローカルランタイム Docker",
    providerKeyLocalRuntimeKvm: "ローカルランタイム KVM",
    providerKeyAliyunAckContainer: "Aliyun ACK Container",
    providerKeyAliyunEcsKvm: "Aliyun ECS KVM",
    providerKeyUnknown: "未定義の提供元",
    sourceTypeQuestionEditorPracticalDebug: "問題エディタ実技デバッグ",
    sourceTypeQuestionEditorAttackDebug: "問題エディタ攻防デバッグ",
    sourceTypeRuntimeDocker: "ランタイム Docker インスタンス",
    objectTypeQuestionEditorDebug: "問題編集デバッグインスタンス",
    objectTypeDockerInstance: "独立コンテナインスタンス",
    environmentTypeDebug: "デバッグ環境",
    instanceKindBusiness: "業務インスタンス",
    instanceKindDebug: "デバッグインスタンス",
    instanceKindRuntime: "ランタイムインスタンス",
    instanceKindPractical: "実訓コンテナインスタンス",
    instanceKindVm: "VM インスタンス",
    instanceKindRuntimeVm: "ランタイム VM インスタンス",
    actionCreateEnvironment: "環境インスタンス作成",
    actionCreateDocker: "コンテナインスタンス作成",
    actionImportTar: "Tar からイメージ取込",
    actionImportAsset: "アセットからイメージ取込",
    actionBuildDockerfile: "Dockerfile ビルド",
  },
} as const;
